import { useNavigate, useSearch } from '@tanstack/react-router';
import { Page, PageHeader } from '@evogard/ui';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@evogard/ui/primitives';
import { useSessionContext } from '../../../lib/session.js';
import { LinesView } from './ManagementScreen.js';
import { PeripheralPanel } from './PeripheralPanel.js';

/**
 * Sinistros › Gestão dos periféricos (28/10/2026, pedido do dono): a Gestão
 * de Periféricos, separada da do sinistro.
 *
 * As mesmas duas sub-abas da Gestão do sinistro, e pelo mesmo motivo: o
 * painel olha um período, e o fluxo em linhas mostra o momento. O painel é a
 * aba principal; o fluxo em linhas fica no endereço (`?view=linhas`). O fluxo
 * é o mapa de Periféricos que morava numa aba dentro da Gestão do sinistro.
 */
export function PeripheralManagementScreen() {
  const { data: context } = useSessionContext();
  const view = useSearch({ from: '/authenticated/claims/management/peripherals' }).view;
  const navigate = useNavigate();
  const tenant = context?.currentTenant.nome;
  return (
    <Page measure="cheia">
      <PageHeader title="Gestão dos periféricos">
        {view !== 'linhas'
          ? `Se os acionamentos de Periféricos de ${tenant} estão andando: quanto tempo cada etapa leva, quanto custa e o que se troca. Os gráficos olham um período; o fluxo em linhas mostra o momento.`
          : `Onde está cada acionamento de Periféricos em processo de ${tenant}. A estrada é o caminho normal, cada marcador é uma etapa, com os acionamentos que estão nela, e o desvio desce do losango. O vermelho é o SLA da fase expirado.`}
      </PageHeader>
      <Tabs
        value={view ?? 'painel'}
        onValueChange={(value) =>
          void navigate({
            to: '/claims/management/peripherals',
            search: { view: value === 'linhas' ? 'linhas' : undefined },
            replace: true,
          })
        }
      >
        <TabsList aria-label="Visões da gestão dos periféricos">
          <TabsTrigger value="painel">Painel</TabsTrigger>
          <TabsTrigger value="linhas">Fluxo em linhas</TabsTrigger>
        </TabsList>
        <TabsContent value="painel" className="pt-5">
          <PeripheralPanel />
        </TabsContent>
        <TabsContent value="linhas" className="pt-5">
          <LinesView scope="perifericos" />
        </TabsContent>
      </Tabs>
    </Page>
  );
}
